<template>
    <el-dialog
            append-to-body
            custom-class="auth-summer-dialog"
            :title="$t('cpts.privacy.title')"
            :visible.sync="dialogVisible"
            width="800px">
        <div class="c_333 content" v-html="info"></div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ $t("cpts.privacy.actions.close") }}</el-button>
            <el-button type="primary" @click="agreeWith">{{ $t("cpts.privacy.actions.accept") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {getPrivacy_policy} from '@/http/api/home'
    export default {
        name: "modalPrivacy",
        data(){
            return{
                dialogVisible:false,
                info:''
            }
        },
        async created(){
            try {
                const res = await getPrivacy_policy()
                this.info = typeof res.data === 'string' ? res.data : ''
            } catch (e) {
                this.info = ''
            }
        },
        methods:{
            open(){
                this.dialogVisible = true
            },
            agreeWith(){
                this.$emit('agree')
                this.dialogVisible = false
            }
        }
    }
</script>

<style scoped>
.content{
    max-height: 500px;
    overflow: auto;
}
</style>
